export const fetchEtablissementAModifier = async (
    numero_finess,
    rechercheEtablissement,
    setEtablissementData,
    sous_categorie
) => {
    try {
        const params = new URLSearchParams();

        if (numero_finess) {
            params.append("numero_finess", numero_finess);
        }

        if (!numero_finess && sous_categorie) {
            params.append("sous_categorie", sous_categorie);
        }

        if (rechercheEtablissement) {
            params.append("rechercheEtablissement", rechercheEtablissement);
        }

        const response = await fetch(`https://carto.api.toobib.org/api/fetch_etablissement?${params.toString()}`);

        if (!response.ok) {
            throw new Error("Failed to fetch établissement data");
        }

        const data = await response.json();
        setEtablissementData(data);
    } catch (err) {
        console.error("Error fetching filtered data:", err);
    }
};






/* Afin de récuperer les sous-catégories disponibles */

export const fetchSousCategories = async (setSousCategories) => {
    try {
        const response = await fetch('https://carto.api.toobib.org/api/fetch_sous_categories');

        if (!response.ok) {
            throw new Error('Failed to fetch sous categories');
        }

        const data = await response.json();
        setSousCategories(data);
    } catch (error) {
        console.error('Error fetching sous categories:', error);
    }
};

